import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { INITPAGING, NOTIFY } from "../based/Constants";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import CreatorServices from "../based/services/CreatorServices";
import { Notify } from "../based/Notify";
import UserServices from "../based/services/PartnerServices";

function PartnerModal({ show, onClose, onSave }) {
    const [creators, setCreators] = useState([]);
    const [page, setPage] = useState({ ...INITPAGING });
    const [partnerUserId, setPartnerUserId] = useState("");

    useEffect(() => {
        getCreator(page);
    }, []);

    const getCreator = async (page) => {
        const [err, data] = await CreatorServices.GetCreators(page);
        if (!err && data && data.listObjects) {
            let options = data.listObjects.map((item) => ({
                value: item.id,
                text: item.userName,
                label: item.userName,
            }));
            setCreators(options);
            setPage(data.paging);
        } else {
            setCreators([]);
            setPage(page);
        }
    };

    const assignPartner = async (userId) => {
        const [err, data] = await UserServices.AssignPartner(userId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Thêm partner thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Thêm partner thất bại");
        }
    };

    return (
        <Wrapper>
            <CommonModal
                show={show}
                onClose={onClose}
                title="Thêm Partner"
                hideOnClose
                customButton={
                    <div className="list-action">
                        <button className="btn btn-danger m-1" onClick={onClose}>
                            Đóng
                        </button>
                        <button
                            className="btn btn-custom m-1"
                            onClick={(e) => {
                                assignPartner(partnerUserId);
                            }}
                        >
                            Xác nhận
                        </button>
                    </div>
                }
            >
                <div className="list-row">
                    <div className="row-item">
                        <label htmlFor="">Chọn tài khoản email</label>
                        <TFUSelect
                            placeholder="Chọn tài khoản"
                            options={creators}
                            value={partnerUserId}
                            onChanged={(value) => setPartnerUserId(value)}
                            name="partnerUserId"
                            handleInputChange={(value) => {
                                getCreator({ ...page, keyword: value });
                            }}
                            required
                        />
                    </div>
                </div>
            </CommonModal>
        </Wrapper>
    );
}

export default PartnerModal;

const Wrapper = styled.div``;
